module.exports = __webpack_public_path__ + "static/ProdRight_1-7f9f2522c7786a200312ecdf32ecf4ea.png";